import React from 'react';
import PropTypes from 'prop-types';
import ErrorTemplateBody from './ErrorTemplateBody';

var Forbidden403Page = React.forwardRef(function (props, ref) {
    var edsContext = props.edsContext;

    var errorTitle = edsContext.formatMessage('component.ErrorPage.403');
    var errorMessage = edsContext.formatMessage('component.ErrorPage.403.message');
    var goBackText = edsContext.formatMessage('component.ErrorPage.goBackText');

    return React.createElement(ErrorTemplateBody, Object.assign({
        largeIllustrationName: props.narrow ? '403Narrow.png' : '403.png',
        errorTitle: errorTitle,
        errorMessage: errorMessage,
        text: goBackText,
        hasAction: true
    }, props, {
        ref: ref
    }));
});

Forbidden403Page.propTypes = {
    edsContext: PropTypes.object,
    narrow: PropTypes.bool
};

export default Forbidden403Page;